import { useUiStore } from '@/features/settings/ui-store.js';

/**
 * The TanStack Query key for the sidebar "Recents" list, scoped to a workspace (global-workspaces
 * phase 2). Conversations are workspace-scoped, so the cached list must vary by the selected
 * workspace — otherwise switching workspaces would show the previous one's conversations until a
 * refetch. Every reader/writer of the recents cache MUST build its key here so optimistic updates
 * land in the same entry the sidebar query renders. `null` (before the default resolves) fetches the
 * caller's own cross-workspace conversations — the legacy unscoped list.
 *
 * Prefix-based invalidations (`invalidateQueries({ queryKey: ['recents'] })`) still match every
 * workspace variant, so only exact-key `setQueryData`/`getQueryData` calls need this helper.
 */
export function recentsKey(
  workspaceId: string | null,
): readonly ['recents', string | null] {
  return ['recents', workspaceId] as const;
}

/** The recents key for the currently-selected workspace, read outside React (optimistic writers). */
export function currentRecentsKey(): readonly ['recents', string | null] {
  return recentsKey(useUiStore.getState().selectedWorkspaceId);
}
